export const initialState = Object.freeze({
  gettingStarted: {
    rooms: [],
    proPlatform: false,
    prices: {},
    packages: {},
    packagesOptions: [],
    plansOptions: [],
    roomsParams: {},
    roomsOptions: [],
    address: {
      address: undefined,
      town: undefined,
      postcode: undefined,
      phone: undefined,
    },
  },
});

export default (state, action) => {
  switch (action.type) {
    case 'gettingStarted/update':
      // debugger;
      return {
        ...state,
        gettingStarted: {
          ...state.gettingStarted,
          ...action.payload,
          // family: {
          //   ...state.gettingStarted.family,
          //   ...(action.payload.family || {}),
          // },
          packages: action.payload.packages || state.gettingStarted.packages || {},
        },
      };
    default:
      throw new Error();
  }
};



// WEBPACK FOOTER //
// ./app/javascript/components/brief/store/reducer.js